import React from 'react'
import { Helmet } from 'react-helmet-async'
import './LegalNoticePage.css'

const LegalNoticePage: React.FC = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Mentions légales - EdenPlaisir.com</title>
        <meta name="description" content="Consultez les mentions légales de EdenPlaisir.com pour connaître les informations légales du site." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      
      <div className="legal-container">
        <h1>Mentions légales</h1>
        <p className="last-updated">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

        <section className="legal-section">
          <h2>1. Informations générales</h2>
          <p>
            Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 
            pour la Confiance dans l'économie numérique, dite L.C.E.N., il est porté à la connaissance 
            des utilisateurs et visiteurs du site EdenPlaisir.com les présentes mentions légales.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Éditeur du site</h2>
          <p><strong>Dénomination sociale :</strong> EdenPlaisir.com</p>
          <p><strong>Forme juridique :</strong> [À compléter selon votre situation]</p>
          <p><strong>Adresse du siège social :</strong> [À compléter]</p>
          <p><strong>Téléphone :</strong> [À compléter]</p>
          <p><strong>Email :</strong> contact@edenplaisir.com</p>
          <p><strong>Directeur de publication :</strong> [À compléter]</p>
          <p><strong>Numéro SIRET :</strong> [À compléter si applicable]</p>
        </section>

        <section className="legal-section">
          <h2>3. Hébergement</h2>
          <p><strong>Hébergeur :</strong> [À compléter avec les informations de votre hébergeur]</p>
          <p><strong>Adresse :</strong> [À compléter]</p>
          <p><strong>Téléphone :</strong> [À compléter]</p>
          <p><strong>Site web :</strong> [À compléter]</p>
        </section>

        <section className="legal-section">
          <h2>4. Accès au site</h2>
          <p>
            Le site EdenPlaisir.com est accessible gratuitement à tout utilisateur disposant d'un accès 
            à Internet. Tous les frais de télécommunication nécessaires pour accéder au service sont 
            à la charge de l'utilisateur.
          </p>
          <p>
            L'accès aux services proposés par le site peut faire l'objet d'une restriction géographique 
            ou d'une limitation technique. L'utilisateur reconnaît que l'éditeur ne saurait être tenu 
            responsable des dommages liés à l'impossibilité d'accéder au site ou aux services.
          </p>
          <p>
            <strong>Note importante :</strong> Le contenu vidéo affiché sur EdenPlaisir.com dépend de la 
            disponibilité et du fonctionnement des services tiers (Eporner, LetsJerktv, Redtube). 
            EdenPlaisir.com ne garantit pas la disponibilité permanente de ce contenu et ne saurait être 
            tenu responsable en cas d'indisponibilité ou de modification de ces services tiers.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Propriété intellectuelle</h2>
          <h3>5.1. Propriété du site</h3>
          <p>
            L'ensemble des éléments constituant le site EdenPlaisir.com, incluant mais sans s'y limiter : 
            le code source, la structure, le design, les graphismes, les logos, les textes éditoriaux, 
            la mise en page, les fonctionnalités et l'organisation générale du site, est la propriété 
            exclusive de EdenPlaisir.com.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication, adaptation de tout ou partie 
            des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf 
            autorisation écrite préalable de EdenPlaisir.com.
          </p>
          <h3>5.2. Contenu vidéo provenant de services tiers</h3>
          <p>
            <strong>Important :</strong> Le contenu vidéo présenté sur EdenPlaisir.com provient de services 
            tiers en libre accès. EdenPlaisir.com n'est <strong>pas</strong> propriétaire de ce contenu vidéo 
            et ne revendique aucun droit de propriété intellectuelle sur celui-ci.
          </p>
          <p>
            Les vidéos sont fournies par les services tiers suivants :
          </p>
          <ul>
            <li><strong>Eporner</strong> - Contenu fourni via leur API en libre accès</li>
            <li><strong>LetsJerktv</strong> - Contenu fourni via leur service en libre accès</li>
            <li><strong>Redtube</strong> - Contenu fourni via leur API en libre accès</li>
          </ul>
          <p>
            EdenPlaisir.com agit uniquement en tant que plateforme d'agrégation et d'affichage de ce 
            contenu. La propriété intellectuelle des vidéos appartient à leurs auteurs respectifs et/ou 
            aux services tiers qui les hébergent.
          </p>
          <p>
            En cas de réclamation concernant le contenu vidéo, EdenPlaisir.com pourra orienter les 
            réclamants vers les services tiers propriétaires du contenu.
          </p>
          <p>
            Toute exploitation non autorisée des éléments du site EdenPlaisir.com (code, design, structure) 
            engage la responsabilité civile et/ou pénale de l'utilisateur et pourra donner lieu à des 
            poursuites judiciaires.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Protection des données personnelles</h2>
          <p>
            Conformément à la Loi Informatique et Libertés du 6 janvier 1978 modifiée et au Règlement 
            Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification 
            et de suppression des données vous concernant.
          </p>
          <p>
            Pour plus d'informations sur le traitement de vos données personnelles, consultez notre 
            <a href="/privacy-policy"> politique de confidentialité</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Cookies</h2>
          <p>
            Le site utilise des cookies pour améliorer l'expérience utilisateur, analyser le trafic et 
            personnaliser le contenu. En continuant à naviguer sur le site, vous acceptez l'utilisation 
            de cookies conformément à notre politique de confidentialité.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Disponibilité du contenu</h2>
          <p>
            En tant que plateforme d'agrégation de contenu tiers, EdenPlaisir.com affiche du contenu provenant 
            des services tiers (Eporner, LetsJerktv, Redtube). EdenPlaisir.com <strong>ne contrôle pas 
            directement</strong> ce contenu et n'exerce aucun contrôle éditorial sur celui-ci.
          </p>
          <p>
            <strong>Nous ne pouvons garantir la disponibilité permanente de tout le contenu affiché sur le site.</strong> 
            Certaines vidéos peuvent devenir indisponibles si les services tiers qui fournissent ce contenu 
            décident de le retirer, de le modifier ou de restreindre son accès, <strong>indépendamment de 
            notre volonté</strong>.
          </p>
          <p>
            Les raisons pour lesquelles un service tiers peut rendre un contenu indisponible incluent, sans s'y limiter :
          </p>
          <ul>
            <li>Des décisions internes du service tiers fournisseur</li>
            <li>Des restrictions légales ou réglementaires appliquées par le service tiers</li>
            <li>Des notifications de violation de droits de propriété intellectuelle ou de droit à l'image reçues par le service tiers</li>
            <li>Des problèmes techniques ou de maintenance affectant le service tiers</li>
            <li>Des modifications des conditions d'utilisation ou des politiques du service tiers</li>
          </ul>
          <p>
            <strong>EdenPlaisir.com ne saurait être tenu responsable en cas d'indisponibilité temporaire ou définitive 
            d'une vidéo due au retrait ou à la modification du contenu par les services tiers.</strong> Aucun 
            remboursement ou compensation ne sera accordé pour ce motif, car cette indisponibilité est 
            indépendante de notre contrôle et de notre volonté.
          </p>
          <p>
            Les utilisateurs sont informés que le contenu accessible via notre plateforme peut être modifié, 
            retiré ou restreint à tout moment par les services tiers, sans préavis ni notification préalable 
            de notre part.
          </p>
          <p>
            En cas de réclamation concernant un contenu présent sur le site, les utilisateurs doivent contacter 
            directement le service tiers fournisseur du contenu concerné (Eporner, LetsJerktv ou Redtube), 
            car EdenPlaisir.com n'a pas le contrôle sur la disponibilité du contenu hébergé par ces services tiers.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Limitation de responsabilité</h2>
          <h3>9.1. Responsabilité concernant le site</h3>
          <p>
            EdenPlaisir.com s'efforce de fournir sur le site des informations aussi précises que possible. 
            Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes et des carences 
            dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui 
            fournissent ces informations.
          </p>
          <p>
            EdenPlaisir.com ne pourra être tenu responsable des dommages directs et indirects causés au 
            matériel de l'utilisateur, lors de l'accès au site EdenPlaisir.com, et résultant soit de 
            l'utilisation d'un matériel ne répondant pas aux spécifications, soit de l'apparition 
            d'un bug ou d'une incompatibilité.
          </p>
          <h3>9.2. Responsabilité concernant le contenu vidéo tiers</h3>
          <p>
            <strong>EdenPlaisir.com décline toute responsabilité concernant le contenu vidéo fourni par 
            les services tiers.</strong> Ce contenu est hébergé et géré par les services tiers (Eporner, 
            LetsJerktv, Redtube) et EdenPlaisir.com n'exerce aucun contrôle éditorial sur ce contenu.
          </p>
          <p>
            EdenPlaisir.com ne peut être tenu responsable de :
          </p>
          <ul>
            <li>La disponibilité, l'exactitude, la qualité ou la légalité du contenu vidéo fourni par les services tiers</li>
            <li>Les dommages résultant de l'utilisation ou de l'impossibilité d'utiliser le contenu vidéo tiers</li>
            <li>Les violations de droits de propriété intellectuelle concernant le contenu vidéo tiers</li>
            <li>Les interruptions de service ou les modifications apportées par les services tiers à leur API ou leur contenu</li>
          </ul>
          <p>
            En cas de problème avec le contenu vidéo, l'utilisateur doit contacter directement le service 
            tiers concerné.
          </p>
          <h3>9.3. Autres limitations</h3>
          <p>
            EdenPlaisir.com ne pourra également être tenu responsable des dommages indirects consécutifs 
            à l'utilisation du site. Des espaces interactifs (commentaires, forums) sont à la disposition 
            des utilisateurs. EdenPlaisir.com se réserve le droit de supprimer, sans mise en demeure 
            préalable, tout contenu déposé dans cet espace qui contreviendrait à la législation applicable 
            en vigueur en France.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Droit applicable et juridiction compétente</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut 
            d'accord amiable, le litige sera porté devant les tribunaux conformément à la législation 
            française en vigueur.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Modifications des mentions légales</h2>
          <p>
            EdenPlaisir.com se réserve le droit de modifier les présentes mentions légales à tout moment. 
            L'utilisateur s'engage donc à les consulter de manière régulière. Les modifications prennent 
            effet dès leur publication sur le site.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Contact</h2>
          <p>
            Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter :
          </p>
          <ul>
            <li><strong>Par email :</strong> contact@edenplaisir.com</li>
            <li><strong>Par courrier :</strong> [Adresse postale à compléter]</li>
          </ul>
        </section>
      </div>
    </div>
  )
}

export default LegalNoticePage

